import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import NokiaFontRegular from '@nokia-csf-uxr/ccfk-assets/fonts/NokiaPureText-Regular.woff';
import NokiaFontBold from '@nokia-csf-uxr/ccfk-assets/fonts/NokiaPureText-Bold.woff';
import { CONFIG } from "../../config";


/**
 * Generation of the PDF for a link BoQ
 */

/**
 * Register Nokia fonts
 */
Font.register({
    family: 'NokiaFont',
    fonts: [
      {
        src: NokiaFontRegular,
      },
      {
        src: NokiaFontBold,
        fontWeight: 'bold',
      }
    ],
  });
  
  /**
 * Style for the data grid with boq
 */
const LINK_BOQ_STYLE = StyleSheet.create({
    table: { 
      display: "table", 
      width: "90%",
      left: "5%",
      borderStyle: "solid", 
      borderWidth: 1, 
//      borderRightWidth: 0, 
//      borderBottomWidth: 0 
    }, 
    tableRow: { 
      //flex: 1,
      flexDirection: "row",
      alignContent: "left" 
    }, 
    tableRowCategory: { 
      flexDirection: "row",
      alignContent: "left",
      backgroundColor: "lightgrey",
      borderStyle: "solid",
      width: "100%", 
      borderBottomWidth: 0,
      borderRightWidth: 0, 
      borderLeftWidth: 0, 
      borderTopWidth: 0.5
    }, 
    tableColPartNbr: { 
      //flex: 1,
      width: "15%", 
      borderStyle: "solid", 
      borderBottomWidth: 0,
      borderRightWidth: 0, 
      borderLeftWidth: 0, 
      borderTopWidth: 0
    },
    tableColDescr: { 
      //flex: 1,
      width: "75%", 
      alignContent: "left",
      borderStyle: "solid", 
      borderBottomWidth: 0,
      borderRightWidth: 0, 
      borderLeftWidth: 0, 
      borderTopWidth: 0
    }, 
    tableColQty: { 
      //flex: 1,
      width: "10%", 
      borderStyle: "solid", 
      borderBottomWidth: 0,
      borderRightWidth: 0, 
      borderLeftWidth: 0, 
      borderTopWidth: 0
    },         
    tableCol100: {
      //display: "flex",
      flex: 1,
      width: "100%", 
      //borderStyle: "solid",
      //borderWidth: 1,
      //backgroundColor: "lightgrey",
      //borderLeftWidth: 0, 
      //borderTopWidth: 0
    },     
    tableCell: { 
      margin: "auto", 
      marginTop: 5,
      marginBottom: 5
    },     
    tableCellLeft: { 
      //flex: 1,
      //margin: "auto",
      textAlign: "left",
      marginLeft: 5,
      marginTop: 5,
      marginBottom: 5
    },     
    tableCellCategory: { 
      //margin: "auto", 
      textAlign: "left",
      fontWeight: "bold",
      marginLeft: 5,
      marginTop: 5,
      marginBottom: 5
    },
    columnName: { 
      margin: "auto", 
      marginTop: 5,
      marginBottom: 5,
      fontFamily: "NokiaFont",
      fontWeight: "bold"
    },
    columnNameLeft: {  
      marginLeft: 5,
      marginTop: 5,
      marginBottom: 5,
      textAlign: "left",
      fontFamily: "NokiaFont",
      fontWeight: "bold"
    }
  });
  
  /**
 * Generate a table which contains calculated information of the link
 * @param {*} props 
 * @returns 
 */
const LinkBoQTable = (props) => {

  let lines = []
  let totalLines = (props.data?.length)
  let linkBoQ = (props?.data)

  for (let i = 0; i < totalLines; i++) {
    let lineCategory = [];
    let line = [];
    
    if (i === 0) {
      lineCategory.push(<><View style={LINK_BOQ_STYLE.tableRowCategory}> 
        <View style={LINK_BOQ_STYLE.tableCol100}> 
          <Text style={LINK_BOQ_STYLE.tableCellCategory}>{ linkBoQ[i].exportCategory }</Text> 
        </View> 
      </View></>);
      
      lines.push(<View style={LINK_BOQ_STYLE.tableRowCategory}>{lineCategory}</View>)
    }

    if (i > 0) {
      if (linkBoQ[i].exportCategory !== linkBoQ[i-1].exportCategory) {
        lineCategory.push(<><View style={LINK_BOQ_STYLE.tableRowCategory}> 
          <View style={LINK_BOQ_STYLE.tableCol100}> 
            <Text style={LINK_BOQ_STYLE.tableCellCategory}>{ linkBoQ[i].exportCategory }</Text> 
          </View> 
        </View></>);
      
        lines.push(<View style={LINK_BOQ_STYLE.tableRowCategory}>{lineCategory}</View>)
      }
    }

    line.push(<><View style={LINK_BOQ_STYLE.tableRow}> 
      <View style={LINK_BOQ_STYLE.tableColPartNbr}> 
        <Text style={LINK_BOQ_STYLE.tableCellLeft}>{ linkBoQ[i].partNumber }</Text> 
      </View> 
      <View style={LINK_BOQ_STYLE.tableColDescr}> 
        <Text style={LINK_BOQ_STYLE.tableCellLeft}>{ linkBoQ[i].productName == null ? "" : linkBoQ[i].productName }</Text> 
      </View> 
      <View style={LINK_BOQ_STYLE.tableColQty}>
        <Text style={LINK_BOQ_STYLE.tableCell}>{ linkBoQ[i].quantity == null ? "" : linkBoQ[i].quantity }</Text>
      </View> 
    </View></>);
    
    lines.push(<View style={LINK_BOQ_STYLE.tableRow}>{line}</View>)
  }

  return <>
  <View style={LINK_BOQ_STYLE.table}> 
    <View style={LINK_BOQ_STYLE.tableRow}> 
      <View style={LINK_BOQ_STYLE.tableColPartNbr}> 
        <Text style={LINK_BOQ_STYLE.columnNameLeft}>Part number</Text> 
      </View> 
      <View style={LINK_BOQ_STYLE.tableColDescr}> 
        <Text style={LINK_BOQ_STYLE.columnNameLeft}>Description</Text> 
      </View> 
      <View style={LINK_BOQ_STYLE.tableColQty}> 
        <Text style={LINK_BOQ_STYLE.columnName}>Quantity</Text> 
      </View> 
    </View>

    { lines }

  </View>
  </>
}
  
  // Create PDF_STRUCTURE_STYLE
const PDF_STRUCTURE_STYLE = StyleSheet.create({
    page: {
      flexDirection: 'column'
    },
    logo: {
      width: 100,
      marginLeft: "3vw"
    },
    section: {
      width: '100%',
      padding: 30
    },
    titlePDF: {
      position: "absolute",
      width: "200px",
      top: "50%",
      left: "45%",
      transform: "translate(-50%, -15%)", 
      textAlign: "center",
      fontFamily: "NokiaFont",
      fontWeight: "bold",
      fontSize: "10px"
    },
    date: {
      position: "absolute",
      right: "10%",
      top: "30%",
      textAlign: "right",
      fontFamily: "NokiaFont",
      fontSize: "8px"
    },
    rowSection: {
      display: 'flex',
      flexDirection: 'row',
      fontSize: 7,
      marginTop: "5vh"
    },
    footer: {
      position: 'absolute',
      bottom: '10px',
      left: '20%',
      textAlign: 'center',
      fontFamily: 'NokiaFont',
      fontSize: '7px'
    }
  });

  const getDate = () => {
    let date = new Date();
    return date.getDate()+"/"+(date.getMonth()+1)+"/"+date.getFullYear();
  }

  const BoQDetailsPDF = (props) => (
    <Document title={props?.linkBoQ[0].linkName}>
      <Page size="A4" orientation="portrait" style={PDF_STRUCTURE_STYLE.page}>
        <View style={PDF_STRUCTURE_STYLE.rowSection}>
          <Image source="/assets/logo/nokia_logo.png" style={PDF_STRUCTURE_STYLE.logo}></Image>
          <View style={PDF_STRUCTURE_STYLE.titlePDF}>
          <Text>Link {props?.linkBoQ[0].linkName}</Text>
            <Text>Bill of Material</Text>
          </View>
          <View style={PDF_STRUCTURE_STYLE.date}>
            <Text>{ getDate() }</Text>
          </View>
        </View>
        <View style={PDF_STRUCTURE_STYLE.section}>
  
          <View style={PDF_STRUCTURE_STYLE.rowSection}>
  
            <LinkBoQTable data={props?.linkBoQ} />
  
          </View>

        </View>
        <View style={PDF_STRUCTURE_STYLE.footer}>
          <Text>{CONFIG.sentences["page.info.bom.warning"]}</Text>
        </View>
      </Page>
    </Document>
  );
  
  export default BoQDetailsPDF;